import { Link } from 'react-router-dom';
import { Award, Flame } from 'lucide-react';

const Footer = () => {
  const productRange = [
    'Continuous Mesh Belt Hardening Furnace',
    'Rotary Retort Furnaces',
    'Gas Carburizing Furnaces',
    'Normalizing Furnaces',
    'Muffle Furnaces',
    'Salt Bath Furnace',
    'Annealing Furnace',
  ];

  return (
    <footer className="dark-gradient text-white mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Quick Links */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <Award className="text-yellow-400" size={20} />
              <h4 className="text-lg font-semibold text-yellow-400">Quick Links</h4>
            </div>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-yellow-400 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-yellow-400 transition-colors">
                  About
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-gray-300 hover:text-yellow-400 transition-colors">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-yellow-400 transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-yellow-400 transition-colors">
                  Contact
                </Link>
              </li>
            </ul>

            <div className="mt-6 inline-flex items-center gap-2 px-3 py-2 rounded-full bg-orange-500/10 border border-orange-500/40">
              <Award className="text-yellow-400" size={16} />
              <span className="text-xs font-semibold uppercase tracking-wider text-yellow-300">
                ISO 9001 Certified Company
              </span>
            </div>
          </div>

          {/* Product Range */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-yellow-400">Product Range</h4>
            <ul className="space-y-2.5 text-gray-300" data-testid="footer-product-range">
              {productRange.map((p) => (
                <li key={p} className="flex items-start gap-2.5">
                  <Flame className="text-orange-500 flex-shrink-0 mt-1" size={14} />
                  <span>{p}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Get In Touch */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-yellow-400">Get In Touch</h4>
            <address className="text-gray-300 not-italic leading-relaxed">
              <div className="mb-3">
                <div className="font-semibold text-white mb-1">Factories</div>
                Amritsar &amp; Ludhiana
              </div>
              <div className="mb-3">
                <div className="font-semibold text-white mb-1">Registered Address</div>
                173- Mehta Road,<br />
                Focal Point, Industrial Area, Amritsar - 143006,<br />
                Punjab (India)
              </div>
              <div className="mb-1">
                <span className="font-semibold text-white">Phone:</span>{' '}
                <a href="tel:+916280452690" className="text-yellow-400 hover:underline">+91 62804 52690</a>
              </div>
              <div className="mb-1">
                <span className="font-semibold text-white">Phone:</span>{' '}
                <a href="tel:+916239019768" className="text-yellow-400 hover:underline">+91 62390 19768</a>
              </div>
              <div>
                <span className="font-semibold text-white">Email:</span>{' '}
                <a
                  href="mailto:rkkohli.sons@gmail.com"
                  className="text-yellow-400 hover:underline"
                >
                  rkkohli.sons@gmail.com
                </a>
              </div>
            </address>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="text-gray-400 text-sm">
            © {new Date().getFullYear()} Arkotherm Furnaces · All rights reserved
          </div>
          <div className="text-gray-500 text-sm mt-2 md:mt-0">
            Designed by Arkotherm · ISO 9001 Certified Manufacturer
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
